<script setup lang="ts">
import { onMounted, onBeforeMount } from "vue"
import { useRouter, useRoute } from "vue-router"

import MainWeb from '@/components/mainWeb.vue';

const router = useRouter();
const route = useRoute();
const isYZXMode = import.meta.env.VITE_CONFIG_MODE === "YZX";

onBeforeMount(async () => {
  if (route.path === "/") {
    router.push({ name: isYZXMode ? "landing" : "main" })
  }
})
</script>

<template>
    <MainWeb />
</template>
